export default __webpack_public_path__ + "static/media/intro_img1.cf17f409.png";